const team = [
  {
    id: 'michael-jackson',
    name: 'Michael Jackson',
    avatarUrl: '/images/avatars/michael-jackson.jpg',
    twitterHandle: 'mjackson',
  },
  {
    id: 'ryan-florence',
    name: 'Ryan Florence',
    avatarUrl: '/images/avatars/ryan-florence.jpg',
    twitterHandle: 'ryanflorence',
  },
  {
    id: 'brad-westfall',
    name: 'Brad Westfall',
    avatarUrl: '/images/avatars/brad-westfall.jpg',
    twitterHandle: 'bradwestfall',
  },
  {
    id: 'chance-strickland',
    name: 'Chance Strickland',
    avatarUrl: '/images/avatars/chance-strickland.jpg',
    twitterHandle: 'chancethedev',
  },
  {
    id: 'david-khourshid',
    name: 'David Khourshid',
    avatarUrl: '/images/avatars/david-khourshid.jpg',
    twitterHandle: 'DavidKPiano',
  },
  {
    id: 'cassidy-williams',
    name: 'Cassidy Williams',
    avatarUrl: '/images/avatars/cassidy-williams.jpg',
    twitterHandle: 'cassidoo',
  },
  {
    id: 'james-long',
    name: 'James Long',
    avatarUrl: '/images/avatars/james-long.jpg',
    twitterHandle: 'jlongster',
  },
]

module.exports = team
